import { BACKDROP_CONSTANTS } from '../backdrop';
import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "bottom-sheet";
var classes = {
    DRAGGING: 'tyl-bottom-sheet--dragging',
    FULLSCREEN: 'tyl-bottom-sheet--fullscreen',
    OPEN: 'tyl-bottom-sheet--open',
    SCROLLABLE: 'tyl-bottom-sheet--scrollable'
};
var attributes = {
    BACKDROP_CLOSE: 'backdrop-close',
    ESCAPE_CLOSE: 'escape-close',
    FULLSCREEN: 'fullscreen',
    INITIAL_FOCUS: elementName + "-focus",
    OPEN: elementName + "-open",
    SHOW_BACKDROP: 'show-backdrop'
};
var selectors = {
    BACKDROP: BACKDROP_CONSTANTS.elementName,
    CONTAINER: '.tyl-bottom-sheet',
    CONTENT_BODY: '[tcw-bottom-sheet-body]',
    INITIAL_FOCUS: "[" + attributes.INITIAL_FOCUS + "]",
    HOST: "[" + elementName + "-host]",
};
var events = {
    BEFORE_CLOSE: "tcw-bottom-sheet-before-close",
    CLOSE: "tcw-bottom-sheet-close",
    OPEN: "tcw-bottom-sheet-open",
    READY: "tcw-bottom-sheet-ready",
    DRAG_START: "tcw-bottom-sheet-drag-start",
    DRAGGED: "tcw-bottom-sheet-dragged",
    DRAG_END: "tcw-bottom-sheet-drag-end",
    DRAG_CANCEL: "tcw-bottom-sheet-drag-cancel",
    FULLSCREEN: "tcw-bottom-sheet-fullscreen"
};
export var BOTTOM_SHEET_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    events: events
};
